import { useLazyGetCallSessionDetailQuery } from 'services';

export function useLazyCallSessionDetail() {
  const [trigger, { data: callSessionResponse, isLoading }] = useLazyGetCallSessionDetailQuery();

  const handleLoadCallSessionDetail = async (callSessionId: number) => {
    if (!callSessionId) return null;
    const response = await trigger(callSessionId).unwrap();
    return response.data;
  };

  return {
    loadCallSessionDetail: handleLoadCallSessionDetail,
    data: callSessionResponse?.data,
    isLoading
  };
}
